Vue.component('admin-traits', {
  template: templates.adminTraits,
  data() {
    return {
      model: {
        edit: false,
        creating: false,
        trait: {
          id: null,
          name: null,
          description: null,
          category: null,
          duration: null
        },
        traits: []
      }
    }
  },
  mounted() {
    this.get();
  },
  methods: {
    get() {
      const c = this;

      traitService.get()
        .then(function(response) {
          c.model.traits = response.data.map(function(record) {
            return {
              id: record.id,
              name: record.name,
              description: record.description,
              category: record.category || '—',
              duration: record.duration !== null && record.duration !== undefined ? record.duration : null,
              durationDisplay: record.duration !== null && record.duration !== undefined ? record.duration + ' turns' : '∞'
            };
          });
        })
        .catch(function() {
          utils.alert.error('Failed to load traits.');
        });
    },
    create() {
      const c = this;
      c.model.edit = true;
      c.model.creating = true;
      c.model.trait = { id: null, name: null, description: null, category: null };
    },
    edit(id) {
      const c = this;
      const trait = c.model.traits.find(t => t.id === id);
      if (!trait) { return; }

      if (c.model.trait.id === id && !c.model.creating) {
        c.model.edit = false;
        return;
      }

      c.model.edit = true;
      c.model.creating = false;
      c.model.trait = {
        id: trait.id,
        name: trait.name,
        description: trait.description,
        category: trait.category !== '—' ? trait.category : null,
        duration: trait.duration !== null && trait.duration !== undefined ? trait.duration : null
      };
    },
    save() {
      const c = this;

      if (!c.model.trait.name) {
        utils.alert.error('Name is required.');
        return;
      }
      if (!c.model.trait.description) {
        utils.alert.error('Description is required.');
        return;
      }

      traitService.save(c.model.trait)
        .then(function(response) {
          const dur = c.model.trait.duration !== '' && c.model.trait.duration !== null ? Number(c.model.trait.duration) : null;
          const durDisplay = dur !== null ? dur + ' turns' : '∞';

          if (c.model.creating) {
            c.model.traits.push({
              id: response.data.id,
              name: c.model.trait.name,
              description: c.model.trait.description,
              category: c.model.trait.category || '—',
              duration: dur,
              durationDisplay: durDisplay
            });
          } else {
            const row = c.model.traits.find(t => t.id === c.model.trait.id);
            if (row) {
              row.name            = c.model.trait.name;
              row.description     = c.model.trait.description;
              row.category        = c.model.trait.category || '—';
              row.duration        = dur;
              row.durationDisplay = durDisplay;
            }

            if (window.traits && traits.definitions[c.model.trait.id]) {
              traits.definitions[c.model.trait.id].label = c.model.trait.name;
              traits.definitions[c.model.trait.id].description = c.model.trait.description;
            }
          }

          c.reset();
          utils.alert.success('Saved!');
        })
        .catch(function() {
          utils.alert.error('Failed to save.');
        });
    },
    reset() {
      const c = this;
      c.model.edit = false;
      c.model.creating = false;
      c.model.trait = {
        id: null,
        name: null,
        description: null,
        category: null,
        duration: null
      };
    }
  }
});
